import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import DropdownItem from "@/components/views/account/settings/interests/dropdown/DropdownItem";
import { cn } from "@/lib/utils";

interface DropdownProps {
  icon?: any;
  data: any[];
  selectedData: any;
  setSelectedData: (data: any) => void;
  onClose: () => void;
  loading: boolean;
  hasMore?: boolean;
  nextData?: (currentPage: number) => void;
  multipleSelect?: boolean;
  height?: number;
}

export default function Dropdown(props: DropdownProps) {
  const { icon, multipleSelect, data, nextData, hasMore, loading } = props;
  const [currentPage, setCurrentPage] = useState(1);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener(
      "resize",
      (e) => {
        setWidth(window.innerWidth);
      },
      true,
    );

    return () =>
      window.removeEventListener(
        "resize",
        (e) => {
          setWidth(window.innerWidth);
        },
        true,
      );
  }, []);

  return (
    <div
      className={cn(
        "w-full  px-6 py-2 rounded-3xl z-40 flex-col justify-start items-start flex",
        props.height ? props.height : `h-[204px]`,
      )}
    >
      <InfiniteScroll
        style={{
          overflowX: "hidden",
        }}
        height={props.height ? props.height : width >= 768 ? 198 : 300}
        next={() => {
          if (nextData) nextData(currentPage);
          setCurrentPage(currentPage + 1);
        }}
        hasMore={hasMore ?? false}
        dataLength={data.length || 0}
        className="min-w-full"
        loader={
          hasMore && (
            <div className="text-center text-primary font-bold">
              Yükleniyor...
            </div>
          )
        }
      >
        {data?.map((data: any) => (
          <DropdownItem
            icon={icon}
            multipleSelect={multipleSelect}
            loading={loading}
            key={data.id}
            data={data}
            selectedData={props.selectedData}
            setSelected={props.setSelectedData}
            onClose={props.onClose}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
}
